import { render } from "./DraftTreeSubtree.vue?vue&type=template&id=8658161c&scoped=true&ts=true"
import script from "./DraftTreeSubtree.vue?vue&type=script&lang=ts"
export * from "./DraftTreeSubtree.vue?vue&type=script&lang=ts"

import "./DraftTreeSubtree.vue?vue&type=style&index=0&id=8658161c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8658161c"]])

export default __exports__